(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var _themeChanger = _interopRequireDefault(require("./modules/themeChanger.js"));
var _playgroundGridTemplateColumns = _interopRequireDefault(require("./modules/playgrounds/playgroundGridTemplateColumns.js"));
var _playgroundGridTemplateRows = _interopRequireDefault(require("./modules/playgrounds/playgroundGridTemplateRows.js"));
var _playgroundJustifyContent = _interopRequireDefault(require("./modules/playgrounds/playgroundJustifyContent.js"));
var _playgroundFlexDirection = _interopRequireDefault(require("./modules/playgrounds/playgroundFlexDirection.js"));
var _playgroundAlignItems = _interopRequireDefault(require("./modules/playgrounds/playgroundAlignItems.js"));
var _playgroundGap = _interopRequireDefault(require("./modules/playgrounds/playgroundGap.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
// Import JS classes

// Import playgrounds

// Initiate JS classes
var theme = new _themeChanger["default"]();
var gridtemplatecolumns = new _playgroundGridTemplateColumns["default"]();
var gridtemplaterows = new _playgroundGridTemplateRows["default"]();
var justifycontent = new _playgroundJustifyContent["default"]();
var flexdirection = new _playgroundFlexDirection["default"]();
var alignitems = new _playgroundAlignItems["default"]();
var gap = new _playgroundGap["default"]();

},{"./modules/playgrounds/playgroundAlignItems.js":2,"./modules/playgrounds/playgroundFlexDirection.js":3,"./modules/playgrounds/playgroundGap.js":4,"./modules/playgrounds/playgroundGridTemplateColumns.js":5,"./modules/playgrounds/playgroundGridTemplateRows.js":6,"./modules/playgrounds/playgroundJustifyContent.js":7,"./modules/themeChanger.js":8}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var playgroundAlignItems = /*#__PURE__*/function () {
  function playgroundAlignItems() {
    _classCallCheck(this, playgroundAlignItems);
    this.events();
  }
  return _createClass(playgroundAlignItems, [{
    key: "events",
    value: function events() {
      var _this = this;
      var buttons = document.querySelectorAll("#align-items .playground-options button");
      buttons.forEach(function (element) {
        element.addEventListener("click", function (event) {
          _this.changePlayground(event);
        });
      });
    }
  }, {
    key: "changePlayground",
    value: function changePlayground(event) {
      var buttonClass = event.target.classList;
      var playground = document.querySelector("#align-items .playground-preview");
      if (buttonClass.contains('flex-start')) {
        playground.style.alignItems = "flex-start";
      }
      if (buttonClass.contains('center')) {
        playground.style.alignItems = "center";
      }
      if (buttonClass.contains('flex-end')) {
        playground.style.alignItems = "flex-end";
      }
      if (buttonClass.contains('stretch')) {
        playground.style.alignItems = "stretch";
      }
    }
  }]);
}();
var _default = exports["default"] = playgroundAlignItems;

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var playgroundFlexDirection = /*#__PURE__*/function () {
  function playgroundFlexDirection() {
    _classCallCheck(this, playgroundFlexDirection);
    this.events();
  }
  return _createClass(playgroundFlexDirection, [{
    key: "events",
    value: function events() {
      var _this = this;
      var buttons = document.querySelectorAll("#flex-direction .playground-options button");
      buttons.forEach(function (element) {
        element.addEventListener("click", function (event) {
          _this.changePlayground(event);
        });
      });
    }
  }, {
    key: "changePlayground",
    value: function changePlayground(event) {
      var buttonClass = event.target.classList;
      var playground = document.querySelector("#flex-direction .playground-preview");
      if (buttonClass.contains('row')) {
        playground.style.flexDirection = "row";
      }
      if (buttonClass.contains('row-reverse')) {
        playground.style.flexDirection = "row-reverse";
      }
      if (buttonClass.contains('column')) {
        playground.style.flexDirection = "column";
      }
      if (buttonClass.contains('column-reverse')) {
        playground.style.flexDirection = "column-reverse";
      }
    }
  }]);
}();
var _default = exports["default"] = playgroundFlexDirection;

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var playgroundGap = /*#__PURE__*/function () {
  function playgroundGap() {
    _classCallCheck(this, playgroundGap);
    this.events();
  }
  return _createClass(playgroundGap, [{
    key: "events",
    value: function events() {
      var _this = this;
      var buttons = document.querySelectorAll("#gap .playground-options button");
      buttons.forEach(function (element) {
        element.addEventListener("click", function (event) {
          _this.changePlayground(event);
        });
      });
    }
  }, {
    key: "changePlayground",
    value: function changePlayground(event) {
      var buttonClass = event.target.classList;
      var playground = document.querySelector("#gap .playground-preview");
      if (buttonClass.contains('0')) {
        playground.style.gap = "0.5em";
      }
      if (buttonClass.contains('20')) {
        playground.style.gap = "20px";
      }
      if (buttonClass.contains('percent')) {
        playground.style.gap = "10%";
      }
      if (buttonClass.contains('calc')) {
        playground.style.gap = "calc(10% + 5px)";
      }
    }
  }]);
}();
var _default = exports["default"] = playgroundGap;

},{}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var playgroundGridTemplateColumns = /*#__PURE__*/function () {
  function playgroundGridTemplateColumns() {
    _classCallCheck(this, playgroundGridTemplateColumns);
    this.events();
  }
  return _createClass(playgroundGridTemplateColumns, [{
    key: "events",
    value: function events() {
      var _this = this;
      var buttons = document.querySelectorAll("#grid-template-columns .playground-options button");
      buttons.forEach(function (element) {
        element.addEventListener("click", function (event) {
          _this.changePlayground(event);
        });
      });
    }
  }, {
    key: "changePlayground",
    value: function changePlayground(event) {
      var buttonClass = event.target.classList;
      var playground = document.querySelector("#grid-template-columns .playground-preview");
      if (buttonClass.contains('fr')) {
        playground.style.gridTemplateColumns = "1fr 1fr";
      }
      if (buttonClass.contains('repeat-fr')) {
        playground.style.gridTemplateColumns = "repeat(4, 1fr)";
      }
      if (buttonClass.contains('percent')) {
        playground.style.gridTemplateColumns = "20% 40% 20% 15%";
      }
      if (buttonClass.contains('combination')) {
        playground.style.gridTemplateColumns = "1fr 100px 20%";
      }
    }
  }]);
}();
var _default = exports["default"] = playgroundGridTemplateColumns;

},{}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var playgroundGridTemplateRows = /*#__PURE__*/function () {
  function playgroundGridTemplateRows() {
    _classCallCheck(this, playgroundGridTemplateRows);
    this.events();
  }
  return _createClass(playgroundGridTemplateRows, [{
    key: "events",
    value: function events() {
      var _this = this;
      var buttons = document.querySelectorAll("#grid-template-rows .playground-options button");
      buttons.forEach(function (element) {
        element.addEventListener("click", function (event) {
          _this.changePlayground(event);
        });
      });
    }
  }, {
    key: "changePlayground",
    value: function changePlayground(event) {
      var buttonClass = event.target.classList;
      var playground = document.querySelector("#grid-template-rows .playground-preview");
      if (buttonClass.contains('repeat-fr')) {
        playground.style.gridTemplateRows = "repeat(4, 1fr)";
      }
      if (buttonClass.contains('pixels')) {
        playground.style.gridTemplateRows = "80px 50px 80px 50px";
      }
      if (buttonClass.contains('percent')) {
        playground.style.gridTemplateRows = "20% 40% 30% 10%";
      }
      if (buttonClass.contains('combination')) {
        playground.style.gridTemplateRows = "1fr 100px 20% 1fr";
      }
    }
  }]);
}();
var _default = exports["default"] = playgroundGridTemplateRows;

},{}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var playgroundJustifyContent = /*#__PURE__*/function () {
  function playgroundJustifyContent() {
    _classCallCheck(this, playgroundJustifyContent);
    this.events();
  }
  return _createClass(playgroundJustifyContent, [{
    key: "events",
    value: function events() {
      var _this = this;
      var buttons = document.querySelectorAll("#justify-content .playground-options button");
      buttons.forEach(function (element) {
        element.addEventListener("click", function (event) {
          _this.changePlayground(event);
        });
      });
    }
  }, {
    key: "changePlayground",
    value: function changePlayground(event) {
      var buttonClass = event.target.classList;
      var playground = document.querySelector("#justify-content .playground-preview");
      if (buttonClass.contains('flex-start')) {
        playground.style.justifyContent = "flex-start";
      }
      if (buttonClass.contains('center')) {
        playground.style.justifyContent = "center";
      }
      if (buttonClass.contains('flex-end')) {
        playground.style.justifyContent = "flex-end";
      }
      if (buttonClass.contains('space-between')) {
        playground.style.justifyContent = "space-between";
      }
      if (buttonClass.contains('space-around')) {
        playground.style.justifyContent = "space-around";
      }
    }
  }]);
}();
var _default = exports["default"] = playgroundJustifyContent;

},{}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var themeChanger = /*#__PURE__*/function () {
  function themeChanger() {
    _classCallCheck(this, themeChanger);
    this.events();
  }
  return _createClass(themeChanger, [{
    key: "events",
    value: function events() {
      var _this = this;
      document.documentElement.setAttribute('data-theme', 'dark');
      document.querySelector('.toggle-theme').addEventListener('click', function (event) {
        _this.changeTheme(event);
      });
    }
  }, {
    key: "changeTheme",
    value: function changeTheme(event) {
      var moon = document.querySelector('.toggle-theme i');
      if (!event.target.classList.contains('is-clicked')) {
        event.target.classList.add('is-clicked');
        document.documentElement.setAttribute('data-theme', 'light');
        moon.classList.remove('fa-solid');
        moon.classList.add('fa-regular');
      } else {
        event.target.classList.remove('is-clicked');
        document.documentElement.setAttribute('data-theme', 'dark');
        moon.classList.remove('fa-regular');
        moon.classList.add('fa-solid');
      }
    }
  }]);
}();
var _default = exports["default"] = themeChanger;

},{}]},{},[1]);
